// extracted by mini-css-extract-plugin
var _1 = "jrKgs";
var _2 = "LYz8L";
var _3 = "wijqD";
var _4 = "xSc_3";
var _5 = "POekg";
var _6 = "_1eoA";
var _7 = "P5Pvf";
var _8 = "Y6JQr";
export { _1 as "base", _2 as "bolder", _3 as "fullWidth", _4 as "label", _5 as "reverse", _6 as "switch", _7 as "theme-dark", _8 as "theme-light" }
